export const translations = {
  en: {
    uploadTitle: 'Upload Your Files',
    uploadCompletedTitle: 'Upload Completed',
    yourEmail: 'Your Email',
    yourNameOptional: 'Your Name (optional)',
    titleOptional: 'Title (optional)',
    personalMessageOptional: 'Personal Message (optional)',
    uploadFilesLabel: 'Upload Files:',
    uploadCoverPhotosLabel: 'Upload Cover Photos (optional):',
    chooseFiles: 'Choose files',
    noFilesChosen: 'No files chosen',
    termsText: 'I agree to the Terms and Conditions',
    sendButton: 'Send',
    enterOtpPlaceholder: 'Enter OTP',
    verifyOtpButton: 'Verify OTP',
    downloading: 'Loading...',
    downloadButton: 'Download Files',
    linkExpires: 'This link will expire on',
    poweredBy: 'Powered by Clickz',
    onlyJpgFiles: 'Only JPG files are allowed for cover photos.',
    otpSent: 'OTP sent to your email.',
    missingCaptcha: 'Please complete the CAPTCHA to proceed.',
    missingEmail: 'Email is required.',
    uploadSizeExceeded: 'The total upload size exceeds the maximum allowed.',
    pleaseUploadAtLeastOne: 'Please upload at least one file.',
    coverPhotosLimit: 'You can upload up to 5 cover photos only.',
    captchaPrompt: 'Complete the CAPTCHA to prove you are human.',
    of: 'of',
    filesChosen: 'files selected',
    fileChosen: 'file selected',
    otpVerified: 'OTP verified. Preparing to upload files.',
    errorVerifyingOtp: 'Error verifying OTP.',
    filesUploadedSuccessfully: 'Files uploaded successfully.',        
    errorDuringStreamingUpload: 'Error during upload.',
    preparingCoverPhotos: 'Preparing cover photos...',
    missingUploadAuthToken: 'Missing upload authentication token. Please verify OTP again.',
    failedUploadCoverPhoto: 'Failed to upload cover photo.',
    initializingStreamingZipSession: 'Initializing files upload...',    
    sessionCreatedUploadingFilesSequentially: 'Session created. Uploading files sequentially...',
    uploadingFile: 'Uploading file',
    uploadingFiles: 'Uploading files',
    fileUploadError: 'Error uploading file.',
    finalizingArchive: 'Finalizing archive...',   
    uploadingZipPart: 'Uploading ZIP part', 
    estimatedTimeRemaining: 'Estimated time remaining',
    minutes: 'minutes',
    seconds: 'seconds'


  },
  he: {
    uploadTitle: 'העלאת קבצים',
    uploadCompletedTitle: 'ההעלאה הושלמה',
    yourEmail: 'דואר אלקטרוני',
    yourNameOptional: 'שם השולח (אופציונלי)',
    titleOptional: 'כותרת (אופציונלי)',
    personalMessageOptional: 'הודעה אישית (אופציונלי)',
    uploadFilesLabel: 'בחירת קבצים:',
    uploadCoverPhotosLabel: 'תמונות רקע (אופציונלי):',
    chooseFiles: 'בחר קבצים',
    noFilesChosen: 'לא נבחרו קבצים',
    termsText: 'אני מסכים לתנאים ולכללים',
    sendButton: 'שלח',
    enterOtpPlaceholder: 'קוד האימות שהתקבל בדואר האלקטרוני',
    verifyOtpButton: 'אמת קוד',
    downloading: 'טוען...',
    downloadButton: 'הורדת קבצים',
    linkExpires: 'קישור זה יפוג בתאריך',
    poweredBy: 'מבית Clickz',
    onlyJpgFiles: 'רק קבצי JPG מותרים כתמונות רקע.',
    otpSent: 'קוד אימות נשלח אליכם בדואר האלקטרוני. אם הוא לא מגיע, כדאי לבדוק בתיקיית הספאם.',
    missingCaptcha: 'נא לאשר CAPTCHA כדי להמשיך.',
    missingEmail: 'נדרש אימייל.',
    uploadSizeExceeded: 'גודל ההעלאה הכולל חורג מהמגבלה המותרת.',
    pleaseUploadAtLeastOne: 'אנא העלה לפחות קובץ אחד.',
    coverPhotosLimit: 'ניתן להעלות עד 5 תמונות כיסוי בלבד.',
    captchaPrompt: 'אנא אשר את ה-CAPTCHA כדי לאמת שהינך אדם.',
    of: 'מתוך',
    filesChosen: 'קבצים נבחרו',
    fileChosen: 'קובץ נבחר',
    otpVerified: 'קוד האימות אומת. מתכונן להעלאת הקבצים.',
    errorVerifyingOtp: 'קוד אימות שגוי.',
    filesUploadedSuccessfully: 'הקבצים הועלו בהצלחה.',        
    errorDuringStreamingUpload: 'שגיאה במהלך ההעלאה.',
    preparingCoverPhotos: 'מכין תמונות רקע...',
    missingUploadAuthToken: 'שגיאת אבטחה. נא לאמת את קוד האימות שוב.',
    failedUploadCoverPhoto: 'שגיאה בהעלאת תמונת הרקע.',
    initializingStreamingZipSession: 'מתחיל בהעלאת הקבצים...',    
    sessionCreatedUploadingFilesSequentially: 'החיבור התבצע, מתחיל בהעלאת קבצים...',
    uploadingFile: 'מעלה קובץ',
    uploadingFiles: 'מעלה קבצים',
    fileUploadError: 'שגיאה בהעלאת הקובץ.',
    finalizingArchive: 'פינישים אחרונים...',   
    uploadingZipPart: 'מעלה חלק של ZIP', 
    estimatedTimeRemaining: 'זמן משוער שנותר',
    minutes: 'דקות',
    seconds: 'שניות'
  },
  ru: {
    uploadTitle: 'Загрузите файлы',
    uploadCompletedTitle: 'Загрузка завершена',
    yourEmail: 'Ваш Email',
    yourNameOptional: 'Ваше имя (необязательно)',
    titleOptional: 'Заголовок (необязательно)',
    personalMessageOptional: 'Личное сообщение (необязательно)',
    uploadFilesLabel: 'Загрузить файлы:',
    uploadCoverPhotosLabel: 'Загрузить обложки (необязательно):',
    chooseFiles: 'Выбрать файлы',
    noFilesChosen: 'Файлы не выбраны',
    termsText: 'Я согласен с условиями использования',
    sendButton: 'Отправить',
    enterOtpPlaceholder: 'Введите OTP',
    verifyOtpButton: 'Проверить OTP',
    downloading: 'Загрузка...',
    downloadButton: 'Скачать файлы',
    linkExpires: 'Ссылка истечет',
    poweredBy: 'Работает на Clickz',
    onlyJpgFiles: 'Для обложек допускаются только JPG файлы.',
    otpSent: 'OTP отправлен на ваш Email.',
    missingCaptcha: 'Пожалуйста, пройдите CAPTCHA.',
    missingEmail: 'Требуется Email.',
    uploadSizeExceeded: 'Общий размер загрузки превышает допустимый максимум.',
    pleaseUploadAtLeastOne: 'Пожалуйста, загрузите хотя бы один файл.',
    coverPhotosLimit: 'Вы можете загрузить не более 5 обложек.',
    captchaPrompt: 'Подтвердите CAPTCHA, чтобы подтвердить, что вы не робот.',
    of: 'из',
    filesChosen: 'выбрано файлов', 
    fileChosen: 'выбран файл',
    otpVerified: 'OTP подтвержден. Подготовка к загрузке файлов.',
    errorVerifyingOtp: 'Ошибка при проверке OTP.',
    filesUploadedSuccessfully: 'Файлы успешно загружены.',        
    errorDuringStreamingUpload: 'Ошибка во время загрузки.',
    preparingCoverPhotos: 'Подготовка обложек...',
    missingUploadAuthToken: 'Отсутствует токен аутентификации загрузки. Пожалуйста, повторно подтвердите OTP.',
    failedUploadCoverPhoto: 'Не удалось загрузить обложку.',
    initializingStreamingZipSession: 'Инициализация загрузки файлов...',    
    sessionCreatedUploadingFilesSequentially: 'Сессия создана. Загрузка файлов по очереди...',
    uploadingFile: 'Загрузка файла', 
    uploadingFiles: 'Загрузка файлов',
    fileUploadError: 'Ошибка при загрузке файла.',
    finalizingArchive: 'Завершение архива...',   
    uploadingZipPart: 'Загрузка части ZIP',
    estimatedTimeRemaining: 'Оставшееся время',
    minutes: 'Минуты',
    seconds: 'Секунды'  
  }
};

export function t(lang = 'en', key) {
  return (translations[lang] && translations[lang][key]) || translations.en[key] || key;
}
